export enum EProfession {
	idel = 1
}